// ============================================================================
// Shared formatting helpers — replaces the ~12 duplicated copies in the old app.
// Everything user-facing is Eastern time (Giggle ops standard).
// ============================================================================
const ET = 'America/New_York'

export function fmtPhone(raw) {
  const d = String(raw ?? '').replace(/\D/g, '')
  const n = d.length === 11 && d[0] === '1' ? d.slice(1) : d
  if (n.length !== 10) return String(raw ?? '')
  return `(${n.slice(0, 3)}) ${n.slice(3, 6)}-${n.slice(6)}`
}

/** Normalize to 11-digit US (no +) for provider APIs. */
export function normPhone(raw) {
  const d = String(raw ?? '').replace(/\D/g, '')
  if (d.length === 10) return '1' + d
  if (d.length === 11 && d[0] === '1') return d
  return d
}

export function etTime(ts) {
  return new Date(ts).toLocaleTimeString('en-US', { timeZone: ET, hour: 'numeric', minute: '2-digit' })
}
export function etDay(ts) {
  return new Date(ts).toLocaleDateString('en-US', { timeZone: ET, month: 'short', day: 'numeric' })
}
export function etDT(ts) {
  return new Date(ts).toLocaleString('en-US', { timeZone: ET, month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })
}
export function pct(n, d) { return d ? Math.round((n / d) * 1000) / 10 : 0 }
export function usd(cents) { return '$' + (Number(cents || 0) / 100).toFixed(2) }

// Canonical number labels — one map, not five copies. Extend as numbers change.
export const NUMBER_LABELS = {
  '17869279643': 'Marketing',
  '17869279902': 'Account Notification',
  '18888207580': 'Support',
}
export function numberLabel(raw) {
  return NUMBER_LABELS[normPhone(raw)] || fmtPhone(raw)
}

// One CSV cell, safe for spreadsheets: neutralizes formula-injection (a leading
// = + - @ tab or CR — e.g. an inbound SMS body of `=HYPERLINK(...)`) by prefixing
// a single quote, then quotes/escapes commas, quotes and newlines.
export function csvCell(v) {
  let s = v == null ? '' : String(v)
  if (/^[=+\-@\t\r]/.test(s)) s = "'" + s
  return /[",\n]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s
}
